import React, { useState, useEffect } from 'react';
import { $MeterCreate, $MeterUpdate, MetersVService } from '../../services/V2/gozer';
import { useHistory, useParams } from 'react-router';
import { AddModal } from '../shared/AddModal';
import { EditModal } from '../shared/EditModal';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DataUsageIcon from '@material-ui/icons/DataUsage';
import ImageIcon from '@material-ui/icons/Image';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { authProvider } from '../../services/Security';
import { CustomTable } from '../shared/CustomTable';

export const Meters = () => {
    const history = useHistory();

    const [loading, setLoading] = useState<boolean>(true);
    const [showAdd, setShowAdd] = useState<boolean>(false);
    const [showEdit, setShowEdit] = useState<boolean>(false);
    const [rowData, setRowData] = useState<any>();
    const [token, setToken] = useState<any>();
    const [canViewUsage, setCanViewUsage] = useState<boolean>(false);
    const [canUpdateMeter, setCanUpdateMeter] = useState<boolean>(false);
    const [canCreateMeter, setCanCreateMeter] = useState<boolean>(false);
    const [canReadImages, setCanReadImages] = useState<boolean>(false);
    const [canReadMeterReads, setCanReadMeterReads] = useState<boolean>(false);
    const { serviceAddressId } = useParams<{ serviceAddressId: string }>();

    window.addEventListener('message', event => {
        // IMPORTANT: check the origin of the data!
        if(!event.data) return;
        var data = JSON.parse(event?.data);
        authProvider.setToken(data?.token)
        setToken(data?.token)
        // if (event.origin === 'https://your-first-site.example') {
        //     // The data was sent from your site.
        //     // Data sent with postMessage is stored in event.data:
        // } else {
        //     // The data was NOT sent from your site!
        //     // Be careful! Do not use it. This else branch is
        //     // here just for clarity, you usually shouldn't need it.
        //     return;
        // }
    });

    useEffect(() => {
        let perms = authProvider.getPermissions();
        setCanViewUsage(perms.some((perm: string) => perm === "ReadUsages"));
        setCanUpdateMeter(perms.some((perm: string) => perm === "UpdateMeters"));
        setCanCreateMeter(perms.some((perm: string) => perm === "CreateMeters"));
        setCanReadImages(perms.some((perm: string) => perm === "ReadMeterReaderImages"));
        setCanReadMeterReads(perms.some((perm: string) => perm === "ReadMeterReads"));
    }, [token])// eslint-disable-line react-hooks/exhaustive-deps

    const handleShowEdit = (row) => {
        setRowData(row)
        setShowEdit(true);
    }

    return (
        <React.Fragment>
            {showAdd &&
                <AddModal
                    setShow={setShowAdd}
                    show={showAdd}
                    setLoading={setLoading}
                    loading={loading}
                    addEndpoint={MetersVService.metersVCreate}
                    keys={$MeterCreate.properties}
                    modelName="Service Address Meter"
                    parentId={serviceAddressId}
                    parentsParentId={null}
                    parent={null}
                    parentValues={[]}
                    canReadUserRoles={false}
                    successMessage={null}
                    successCallback={null}
                    canReadMeters={false}
                    canReadServiceAddresses={false}
                    districtId={null}
                />}
            {showEdit &&
                <EditModal
                    modelId={rowData.id}
                    parentId={serviceAddressId}
                    parentsParentId={null}
                    data={rowData}
                    modelName="Service Address Meter"
                    setShow={setShowEdit}
                    setLoading={setLoading}
                    loading={loading}
                    isEdit={true}
                    editEndpoint={MetersVService.metersVUpdateMeter}
                    extraEndpoint={null}
                    deleteEndpoint={null}
                    viewKeys={null}
                    editKeys={$MeterUpdate.properties}
                    extraKeys={null}
                    hardDelete={false}
                    canReadUserRoles={false}
                    canReadMeters={false}
                    canReadServiceAddresses={false}
                    districtId={null}
                />}
            <CustomTable
                title="Meters"
                columns={[
                    { title: 'Meter Id', field: 'id', editable: 'never' },
                    { title: 'Meter Number', field: 'meterNumber', editable: 'never' },
                    { title: 'Type', field: 'type', editable: 'never' },
                    { title: 'Location', field: 'location', editable: 'never' },
                    { title: 'Active?', field: 'isActive', editable: 'never', type: 'boolean' },
                ]}
                dataEndpoint={query => {
                    return new Promise((resolve, reject) => {
                        MetersVService.metersVGetAll(serviceAddressId, {
                            pageNumber: query.page + 1,
                            numberPerPage: query.pageSize,
                            orderBy: query?.orderBy?.field?.toString() ?? "MeterNumber",
                            orderByDesc: query.orderDirection === "desc",
                            filters: [],
                            searchQuery: query.search
                        }).then((x:any) => {
                            resolve({
                                data: x.items ?? [],
                                page: query.page,
                                totalCount: x.numberOfItems ?? 0
                            })
                        }).catch(x => {
                            reject(x)
                        })
                    })
                }}
                actions={[
                    {
                        icon: 'refresh',
                        tooltip: 'Refresh Data',
                        isFreeAction: true,
                        onClick: () => { setLoading(!loading) },
                    },
                    {
                        icon: () => <AddIcon />,
                        tooltip: 'Add Meter',
                        isFreeAction: true,
                        onClick: () => setShowAdd(true),
                        disabled: !canCreateMeter
                    },
                    {
                        icon: () => <EditIcon />,
                        tooltip: 'Edit Meter',
                        onClick: (event, row) => handleShowEdit(row),
                        disabled: !canUpdateMeter
                    },
                    {
                        icon: () => <DataUsageIcon />,
                        tooltip: 'View Usages',
                        onClick: (e, r:any) => history.replace(`/app/service-addresses/${serviceAddressId}/meters/${r.id}/usages`),
                        disabled: !canViewUsage
                    },
                    {
                        icon: () => <ImageIcon />,
                        tooltip: 'View Images',
                        onClick: (e, r:any) => history.replace(`/app/service-addresses/${serviceAddressId}/meters/${r.id}/meter-images`),
                        disabled: !canReadImages
                    },
                    {
                        icon: () => <AccessTimeIcon />,
                        tooltip: 'View Reads',
                        onClick: (e, r:any) => history.replace(`/app/service-addresses/${serviceAddressId}/meters/${r.id}/meter-reads`),
                        disabled: !canReadMeterReads
                    }
                ]}
                refresh={loading} setRefresh={setLoading} pageSize={15} enablePaging={true}
                districtId={null} addedQuery={null} hiddenColumns={[]} setHiddenColumns={() => { } } hiddenColumnsDisabled={true}
                tableHeight={"400px"} enableSearch={false} searchPlaceholder={null} dataSet={null}
            />
        </React.Fragment>
    );
}